import { app } from '../../../../../app';
import { Controller } from './dropbox-sync-mapping.controller';

app.component('dropboxSyncMapping', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./dropbox-sync-mapping.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-sync-mapping/dropbox-sync-mapping.component.js